var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white p-5vw md:p-3vw",domProps:{"innerHTML":_vm._s(_vm.post.body)}})}
var staticRenderFns = []

export { render, staticRenderFns }